var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TitleImage',{attrs:{"image":"home","title":"Escuela Técnica N°2 Olavarría"}}),_c('div',{staticClass:"col-md-9 col-sm-12 container"},[_c('QuickAccess'),_c('Notices',{attrs:{"inSection":true,"limit":6}})],1),_c('Contact')],1)}
var staticRenderFns = []

export { render, staticRenderFns }